export default __webpack_public_path__ + "static/media/default-news.db2695de.jpg";